/**
 * base64 エンコードされた CSV データをブラウザにダウンロードさせる共通 util。
 * WsModalReportDownload._download（private）と同一ロジックを切り出し。
 */
export function downloadCsvFromBase64(fileName: string, fileData: string): void {
  // API は常に base64 で返すためデコードする
  const binaryString = atob(fileData);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i) & 0xff;
  }

  const url = window.URL.createObjectURL(new Blob([bytes], { type: 'text/csv' }));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
  window.URL.revokeObjectURL(url);
}
